<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Articles"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="$router.push({ name: 'articles.new' })" class="btn btn--primary btn--primary--sml" v-if="checkPermission('articles', 'create')">New Article</app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('articles', 'view')">
                <div class="flex flex-wrap -mx-2">
                    <div class="flex w-full px-2">
                        <app-field-text
                            v-model="search"
                            placeholder="Search Articles"
                            class="w-full mr-4"
                            @input="searchArticles"
                        />
                        <app-button
                            element="button"
                            @click="resetSearch"
                            :class="['flex whitespace-no-wrap items-center align-center btn btn--primary btn--primary--sml mb-5']"
                        >
                            Reset Search
                        </app-button>
                    </div>
                </div>

                <strong class="block mb-4">Publishable:</strong>
                <app-table v-if="articles.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Published At
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(a, i) in articles" :key="i">
                            <app-table-cell>
                                {{ a.title }}

                                <router-link :to="{ name: 'articles.drafts.home', params: { id: a.id } }" v-if="a.drafts.length > 0 && checkPermission('articles', 'publishable')" class="mt-2 text-grey block text-xs">
                                    <span v-html="a.drafts.length" class="font-bold"></span> awaiting draft(s)
                                </router-link>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <router-link :to="{ name: 'articles.new.child', params: { id: a.id } }" v-if="a.locale.flag != locale.flag && !isTranslated(a, locale)">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </router-link>
                                    <router-link v-else :to="{ name: 'articles.edit', params: { id: getId(a, locale), page: $route.query.page ? $route.query.page : 1, search: $route.query.search ? $route.query.search : '' } }">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </router-link>
                                </div>
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <app-icon :icon="a.published ? 'check-circle' : 'times-circle'" :class="{'text-green': a.published, 'text-red': !a.published, 'text-lg': true}" />
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                {{ moment(a.published_at).format('D MMM YY') }}
                                <span class="text-xs block mt-1 text-grey">({{ moment(a.published_at).fromNow() }})</span>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'articles.edit', params: { id: a.id, page: $route.query.page ? $route.query.page : 1, search: $route.query.search ? $route.query.search : '' } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('articles', 'edit') && a.children.length < 1">
                                    <app-icon icon="edit" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = a.id" v-if="checkPermission('articles', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <app-pagination-links
                    :response="response"
                    :resources="articles"
                    @next="selectNextPage"
                    @previous="selectPreviousPage"
                />
            </app-box>

            <app-box :loading="loading" :initial="loading" class="mt-8" v-if="drafts.length > 0 && checkPermission('articles', 'view') && checkPermission('articles', 'publishable')">
                <strong class="block mb-4">Drafted:</strong>
                <app-table>
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Title
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Languages
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(d, i) in drafts" :key="i">
                            <app-table-cell>
                                {{ d.title }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <div v-for="(locale, key) in locales" :key="key" v-tooltip="locale.lang" class="inline-block mr-3">
                                    <span v-if="d.locale.flag != locale.flag">
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" style="width: 30px; height: 18px;" class="rounded-lg opacity-25"  />
                                    </span>
                                    <span v-else>
                                        <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="rounded-lg" style="width: 30px; height: 18px;"  />
                                    </span>
                                </div>
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'articles.view', params: { id: d.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('articles', 'edit')">
                                    <app-icon icon="eye" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = d.id" v-if="checkPermission('articles', 'delete')"/>
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a article. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import _ from 'lodash';
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import ConfirmModal from '@/components/modals/ConfirmModal';
    import TextField from '@/components/fields/inputs/Text';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'articles.home',

        data: () => ({
            loading: true,
            articles: [],
            drafts: [],
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
            search: ''
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-confirm-modal': ConfirmModal,
            'app-field-text': TextField,
        },

        created() {
            if (this.$route.query.search && this.$route.query.search !== '') {
                this.search = this.$route.query.search;
            }
        },

        mounted() {
            this.getArticles()
                .then(response => {
                    return this.getDraftArticles();
                })
                .then(response => {
                    this.loading = false;
                });
        },

        methods: {
            searchArticles: _.debounce(function() {
                this.$route.query.page = '1';
                return this.getArticles();
            }, 500),

            resetSearch() {
                this.search = '';
                this.$route.query.search = '';
                this.$route.query.page = '1';
                this.getArticles();
            },

            getArticles() {
                let params = {};

                if (this.$route.query.page) {
                    params.page = this.$route.query.page;
                }

                if (this.search !== '') {
                    this.$route.query.search = this.search;
                    params.search = this.search;
                }

                return Api.request('get', `articles?${this.prepareGetQueryString(params)}`)
                    .then(({ data }) => {
                        this.articles = data.articles;
                        this.response = data;
                    });
            },

            getDraftArticles() {
                return Api.request('get', `articles/drafts`)
                    .then(({ data }) => {
                        this.drafts = data.articles;
                    });
            },

            remove() {
                this.confirmModalOpened = false;
                this.loading = true;

                this.deleteArticles( this.confirmModalId ).then(response => {
                        return this.getArticles();
                    }).then(response => {
                        return this.getDraftArticles();
                    }).then(response => {
                        this.loading = false;
                        this.confirmModalId = false;
                    });
            },

            deleteArticles(id) {
                return Api.request('get', `articles/delete/${id}`);
            },

            isTranslated(article, locale) {
                let translated = false;

                if (article.children.length > 0 && article.locale.flag != locale.flag) {
                    article.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            translated = true;
                        }
                    });
                }

                return translated;
            },

            getId(article, locale) {
                let id = article.id;

                if (article.children.length > 0 && article.locale.flag != locale.flag) {
                    article.children.forEach(child => {
                        if (child.locale.flag == locale.flag) {
                            id = child.id;
                        }
                    });
                }

                return id;
            }
        },

        computed: {
            ...mapGetters({
                locales: 'locales/items'
            })
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/articles/Home.vue